module.exports = __webpack_public_path__ + "static/media/logo.b99a7907.svg";